<template>
  <div class="home">
    <div class="bg_black text_white">
      <div class="ninew bodybox">
        <van-nav-bar
          :title="$t('center.platformInfo')"
          left-arrow
          z-index="9"
          @click-left="$router.push('/Center')"
        >
          <van-icon
            name="./static/img/add_staff.png"
            slot="right"
            @click="$router.push('/PlatformInfoAdd')"
            style="font-size: 24px"
          />
        </van-nav-bar>
      </div>
    </div>
    <!-- fixed -->
    <div class="shopList bodybox ninew">
      <van-cell-group
        inset
        v-for="(item, index) in shops"
        :key="index"
        @click="$router.push('/PlatformInfoEdit/' + item.id)"
      >
        <van-cell
          center
          :title="$t('platform.platname')"
          :value="item.name"
        ></van-cell>
        <van-cell :title="$t('platform.platImage')">
          <template #default>
            <van-image
              v-if="item.image"
              width="120"
              height="120"
              fit="contain"
              :src="item.image.path"
            />
          </template>
        </van-cell>
        <van-cell :title="$t('platform.shopList')" is-link to="/MyClient" />

        <van-cell :title="$t('platform.platCode')">
          <template #default>
            <van-image
              v-if="item.qrcode"
              width="120"
              height="120"
              fit="contain"
              :src="item.qrcode.path"
            />
            <!-- <div class="flexlr">
              <div></div>
              <div class="btnsave custor" @click.stop="downs(item.qrcode.path)">
                保存
              </div>
            </div> -->
          </template>
        </van-cell>
        <div class="flexlr linkwrap">
          <div class="main_text">{{ $t("platform.platLink") }}</div>
          <div class="text_gray">
            {{ item.link }}
            <span
              @click.stop="copyLink(item.link)"
              class="iconfont icon-fuzhi text_black fs-20 custor tag-read"
            ></span>
          </div>
        </div>
        <!-- <van-cell center :title="$t('platform.platLink')"
          >{{ item.link }}
          <span
            @click.stop="copyLink(item.link)"
            class="iconfont icon-fuzhi text_black fs-20 custor tag-read"
          ></span>
        </van-cell> -->
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      shops: [],
    };
  },
  mounted: function () {
    this.getShops();
  },
  computed: {},
  methods: {
    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    downs(picUrl) {
      this.downloadIamge(picUrl, "pic");
    },
    getShops() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url: this.$build + "/api/platform/index",
      })
        .then((res) => {
          console.log(res.data.data);
          if (res.data.status == 200) {
            this.shops = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopList.message"),
          });
        });
    },
    copyLink(data) {
      console.log("link:", data);
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据 赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      this.$toast({
        type: "success",
        message: this.$t("platform.successtips"),
      });
    },
    // toPformDetail(id) {
    //   this.$router.push({ path: "/menu_detail", query: { id: id } });
    // },

    // @click.stop="toPformDetail(item.id)"
  },
};
</script>
<style>
.addShop .van-grid-item__content {
  padding: 0;
}
.addShop .van-image {
  margin: auto;
}
</style>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-nav-bar__left {
  padding: 0;
  left: -4px;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
/deep/ .van-cell-group--inset {
  margin: 0;
  margin-top: 15px;
}
.home {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-color: #f3f3f3;
}
.btnsave {
  background: #2f75f4;
  color: white;
  width: 80px;
  line-height: 30px;
  text-align: center;
}
.shopList {
  /* padding-top: 53px; */
  /* padding-top: 20px; */
  margin-bottom: 50px;
}
.linkwrap {
  padding: 10px 16px;
}
.van-cell-group--inset {
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/Platform/PlatformInfo.vue